import { SharedWidget } from './SharedWidget';

interface FloatingWidgetProps {
  publicId: string;
  position?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
  offset?: { x: number; y: number };
  lang?: string;
  showWelcomeMessage?: boolean;
  showNotificationBubble?: boolean;
  customIcon?: string;
  welcomeMessage?: string;
  enableAnimation?: boolean;
}

export function FloatingWidget({ 
  publicId, 
  position = 'bottom-right',
  offset = { x: 20, y: 20 },
  lang = 'fr',
  showWelcomeMessage = true,
  showNotificationBubble = true,
  customIcon,
  welcomeMessage,
  enableAnimation = true
}: FloatingWidgetProps) {
  // Déterminer si le client est sur mobile
  const isMobile = typeof window !== 'undefined' ? window.innerWidth <= 768 : false;

  return (
    <SharedWidget 
      config={{
        mode: 'floating',
        position,
        offset,
        lang,
        showWelcomeMessage,
        showNotificationBubble,
        customIcon,
        welcomeMessage,
        enableAnimation
      }}
      publicId={publicId}
      isMobile={isMobile}
      preview={false}
    />
  );
}